import Tabs from './tabs'
import { headerCarousel, highlightsCarousel, imagesCarousel } from './sliders'
import triggerCalcBtn from './calc-btn'
// import setVideoTime from './control-videos'

// import initCalc from './calculator'
// import addSmoothScroll from './smoothscroll'
// import initCalcNew from './calculator-new'

headerCarousel()
highlightsCarousel()
imagesCarousel()
triggerCalcBtn()

// setVideoTime()

const allTabContainers = document.querySelectorAll('[data-tabs]')

allTabContainers.forEach(el => {
  const tab = new Tabs(el)
  tab.init()
})

if (window.location.hash) {
  document.querySelector(`a[href="${window.location.hash}"]`).click()
  setTimeout(() => {
    window.scrollTo(0, 0)
  }, 0)
}

function openMobileMenu() {
  const hamburger = document.querySelector('.hamburger')
  const menu = document.querySelector('.c-responsive-menu')
  const menuItems = document.querySelectorAll('.c-responsive-menu__inner a')

  hamburger.addEventListener('click', () => {
    hamburger.classList.toggle('is-active')
    menu.classList.toggle('c-responsive-menu--open')
  })

  menuItems.forEach(menuItem => {
    menuItem.addEventListener('click', () => {
      hamburger.classList.toggle('is-active')
      menu.classList.toggle('c-responsive-menu--open')
    })
  })
}

openMobileMenu()

// addSmoothScroll()
// initCalc()
// initCalcNew()
